import React from 'react'
import moment from 'moment';
import { Col, Row } from 'react-bootstrap';

import { FormControl } from '../../../../facturotopia';
import ListMeses from '../../support/catalogs/ListMeses';
import ListPeriodicidad from '../../support/catalogs/ListPeriodicidad';
import ListMesesBimestral from '../../support/catalogs/ListMesesBimestral';

const InformacionGlobal = (props) => {
  const { InformacionGlobal: local = {} } = props.data

  const rules = InformacionGlobalRules(local);

  const handleOnChange = (event) => {
    const InformacionGlobal = {
      ...local,
      ...event
    }

    props.onFormDataChange({InformacionGlobal});
  }

  const getListMeses = () => {
    const { periodicidad } = local;

    if (periodicidad === '05') {
      return ListMesesBimestral;
    }

    return ListMeses;
  }

  return (
    <>
    <Row>
      <Col xs="12" sm="6">
        <FormControl type="select"
          label="Periodicidad"
          name="periodicidad"
          placeholder=""
          help=""
          rules={ rules.periodicidad }
          value={ local.periodicidad }
          options={ ListPeriodicidad }
          onChange={ handleOnChange }
        />

        <FormControl type="select"
          label="Meses"
          name="meses"
          placeholder=""
          help=""
          rules={ rules.meses }
          value={ local.meses }
          options={ getListMeses() }
          onChange={ handleOnChange }
        />

        <FormControl type="select"
          label="Año"
          name="año"
          placeholder=""
          help=""
          rules={ rules.año }
          value={ local.año }
          options={ listAños }
          onChange={ handleOnChange }
        />
      </Col>
    </Row>
    </>
  )
}

const listAños = [
  {
    label: 'Selecciona',
    value: '',
  },
  {
    label: moment().toDate().getFullYear() - 1,
    value: moment().toDate().getFullYear() - 1,
  },
  {
    label: moment().toDate().getFullYear(),
    value: moment().toDate().getFullYear(),
  },
];

const InformacionGlobalRules = ( data ) => {

  return {
    periodicidad: [
      'required',
      'string',
      'min:1',
    ],
    meses: [
      'required',
      'string',
      'min:1',
    ],
    año: [
      'required',
      'string',
      'min:1',
    ],
  }
};

export default InformacionGlobal;